import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import CustomDatePicker from "../../../CustomDatePicker";
import { getDateAsString } from "../../../../util/date";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ErrorAlert from "../error-alert/ErrorAlert";
import { GroupedTradingPartnerSelect } from "../grouped-trading-partner-select";

const FormFilterJsonViewer = (props) => {
  const {
    formData,
    handleChange,
    handleSubmit,
    resetForm,
    isFormComplete,
    handleChangeDateOfBirth,
    isLoading,
    errors,
    handleCloseErrors,
    tradingPartnerSelected,
    setTradingPartnerSelected,
    payers,
  } = props;

  return (
    <Form
      style={{ width: 400 }}
      onSubmit={async (e) => {
        e.preventDefault();
        await handleSubmit();
      }}
    >
      <Row className="m-0">
        <Col md={12} className="p-0">
          <Form.Group className="m-2">
            <Form.Label>Carrier Name</Form.Label>
            <GroupedTradingPartnerSelect
              tradingPartnerSelected={tradingPartnerSelected}
              setTradingPartnerSelected={setTradingPartnerSelected}
              payers={payers}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="m-0">
        <Col md={6} className="p-0">
          <Form.Group className="m-2">
            <Form.Label>NPI</Form.Label>
            <Form.Control
              name="npi"
              type="number"
              placeholder="Enter NPI number"
              value={formData.npi}
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
        <Col md={6} className="p-0">
          <Form.Group className="m-2">
            <Form.Label>Tax ID</Form.Label>
            <Form.Control
              type="text"
              name="taxId"
              placeholder="Enter tax ID"
              value={formData.taxId}
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="m-0">
        <Col md={6} className="p-0">
          <Form.Group className="m-2">
            <Form.Label>Organization Name</Form.Label>
            <Form.Control
              name="organizationName"
              placeholder="Enter organization name"
              value={formData.organizationName}
              onChange={handleChange}
            />
          </Form.Group>
        </Col>

        <Col md={6} className="p-0">
          <Form.Group className="m-2">
            <Form.Label>Member Id</Form.Label>
            <Form.Control
              name="memberId"
              placeholder="Enter member ID"
              value={formData.memberId}
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="m-0">
        <Col md={6} className="p-0">
          <Form.Group className="m-2">
            <Form.Label>First Name</Form.Label>
            <Form.Control
              name="firstName"
              placeholder="Enter first name"
              value={formData.firstName}
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
        <Col md={6} className="p-0">
          <Form.Group className="m-2">
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              name="lastName"
              placeholder="Enter last name"
              value={formData.lastName}
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
        <Col md={6} className="p-0">
          <Form.Group className="m-2">
            <Form.Label>Date Of Birth</Form.Label>
            <CustomDatePicker
              value={
                typeof formData.dateOfBirth === "string"
                  ? getDateAsString(new Date(formData.dateOfBirth))
                  : formData.dateOfBirth
              }
              name="dateOfBirth"
              onChange={(d) => {
                handleChangeDateOfBirth(d);
              }}
            />
          </Form.Group>
        </Col>

        <Col md={6} className="p-0">
          <Form.Group className="m-2">
            <Form.Label>Group Number</Form.Label>
            <Form.Control
              name="groupNumber"
              type="text"
              placeholder="Enter group number"
              value={formData.groupNumber}
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mt-2 mb-2">
        <Col md={{ offset: 2, span: 4 }}>
          <Button
            className="btn-block"
            variant="primary"
            type="submit"
            disabled={!isFormComplete() || isLoading}
          >
            {!isLoading && " Apply filters"}
            {isLoading && "Please wait"}
            {isLoading && (
              <FontAwesomeIcon icon="spinner" spin style={{ marginLeft: 10 }} />
            )}
          </Button>
        </Col>
        <Col md={4}>
          <Button
            className="btn-block"
            variant="warning"
            type="button"
            onClick={() => {
              resetForm();
            }}
            disabled={isLoading}
          >
            Reset
          </Button>
        </Col>

        {errors.length > 0 &&
          errors.map((error, index) => (
            <Col md={12} key={index}>
              <ErrorAlert
                description={error.description}
                possibleResolutions={error.possibleResolutions}
                index={index}
                handleCloseErrors={handleCloseErrors}
                followupAction={error.followupAction}
              />
            </Col>
          ))}
      </Row>
    </Form>
  );
};

export default FormFilterJsonViewer;
